import { string, number, oneOfType, shape, arrayOf } from 'prop-types';

export const billType = {
  id: number,
  account_id: number,
  external_id: string,
  document_number: string,
  amount: oneOfType([number, string]).isRequired,
  surcharge_amount: number,
  consumption: oneOfType([number, string]).isRequired,
  issued_on: string,
  period_started_on: string,
  period_ended_on: string,
  period: string.isRequired,
  status: string,
  first_expiration_on: string,
  second_expiration_on: string,
  printedBill: string
};

export const billPropTypes = {
  id: number,
  account_id: number,
  external_id: string,
  document_number: string,
  amount: oneOfType([number, string]).isRequired,
  surcharge_amount: number,
  consumption: oneOfType([number, string]).isRequired,
  issued_on: string,
  period_started_on: string,
  period_ended_on: string,
  period: string.isRequired,
  status: string,
  first_expiration_on: string,
  second_expiration_on: string,
  printedBill: string
};

export const billProgressPropTypes = shape({
  consumptionDifference: string,
  moneySaving: string,
  carbonImpact: string,
  percentageSaved: oneOfType([number, string]),
  progressData: arrayOf(
    shape({
      month: string.isRequired,
      lastValue: number,
      lastValueName: string,
      currentValue: number,
      currentValueName: string
    })
  ).isRequired,
  currentYear: number,
  currentMonth: string,
  currentConsumption: number,
  currentYearAccumulated: string,
  lastYear: number,
  lastYearAccumulated: string
});
